module.exports = __webpack_public_path__ + "images/screen-shots/lesson-customization-12f0f9826642339119c4e677e1bf5ca9.png";